export default __webpack_public_path__ + "static/media/fast-forward.5cd355ef.svg";